import NoContents from './NoContents'

export default NoContents
